import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import { ShoppingBag, Store, Gift } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function Shop() {
  const { creatorId } = useParams();
  const [products, setProducts] = useState([]);
  const [q, setQ] = useState("");
  const { add } = useCart();

  const load = async () => {
    const params = new URLSearchParams();
    if (creatorId) params.set("creator_id", creatorId);
    if (q) params.set("q", q);
    const { data } = await api.get(`/shop/products?${params.toString()}`);
    setProducts(data || []);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [creatorId]);

  return (
    <div data-testid="shop-page" className="pt-32 pb-20 px-4 sm:px-8 md:px-12 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-tv-accent font-bold flex items-center gap-2">
            <Store className="w-4 h-4" /> {creatorId ? "Creator Store" : "Tap In Shop"}
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl text-white tracking-tighter mt-2">
            {creatorId ? "Support your creator" : "Shop from indie creators"}
          </h1>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="flex gap-2 flex-wrap">
          <Link
            to="/shop/gifts"
            data-testid="shop-giftshop-link"
            className="bg-gradient-to-r from-yellow-400 to-amber-500 hover:from-yellow-300 hover:to-amber-400 text-black font-bold px-4 py-2 rounded-full inline-flex items-center gap-2 text-sm"
          >
            <Gift className="w-4 h-4" /> Gift Shop
          </Link>
          <input data-testid="shop-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search products…" className="bg-white/5 border border-white/10 rounded-full px-4 py-2 text-white outline-none focus:border-tv-brand w-44 sm:w-64" />
        </form>
      </div>

      {products.length === 0 ? (
        <div data-testid="shop-empty" className="text-white/60 text-center py-12">No products yet — creators can start listing via Studio → Shop.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" data-testid="shop-grid">
          {products.map((p) => (
            <div key={p.id} data-testid={`product-card-${p.id}`} className="tv-glass rounded-xl overflow-hidden group border border-white/5 hover:border-tv-accent/40 transition">
              <Link to={`/shop/product/${p.id}`} className="block aspect-square bg-black">
                <img src={(p.images || [])[0] || "https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=400&q=80"} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </Link>
              <div className="p-3">
                <Link to={`/shop/product/${p.id}`} className="block text-white font-semibold text-sm line-clamp-2 hover:text-tv-brand">{p.title}</Link>
                <div className="text-xs text-white/50 truncate mt-0.5">{p.creator_name}</div>
                <div className="flex items-center justify-between mt-2">
                  <div className="text-tv-accent font-black">${p.price_usd.toFixed(2)}</div>
                  <button data-testid={`add-cart-btn-${p.id}`} onClick={() => add(p.id, 1)} className="bg-tv-accent hover:bg-yellow-400 text-black font-bold text-xs px-3 py-1.5 rounded-full flex items-center gap-1">
                    <ShoppingBag className="w-3 h-3" /> Add
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
